<template>
    <div class="panel panel-default company-panel-outer" v-bind:id="data.id + 'MainPanel'">
        <div v-bind:id="data.id + 'PanelHeading'" class="panel-heading clearfix" v-on:click="togglePanel" role="button">
            <span class="panel-controls pull-right">
                <button v-if="data.id == 'emailaccount'" class="btn-archive" onclick="window.location = '?showArchive=1'">
                    <i class="icon icon-archive"></i>
                </button>

                <div class="badge" v-show="count">{{ count }}</div>
                <i class="icon icon-ctrl" v-bind:class="{ 'icon-down' : showFull, 'icon-up' : !showFull }"></i>
            </span>

            <h3 class="panel-title">
                <i v-bind:class="'icon ' + data.icon"></i>{{ data.title }}
                <a v-on:click.stop="newItem" @contextmenu.prevent="newItemAlt" type="button" class="btn-create" v-bind:class="{ 'disabled': checkDisabled }"><i class="icon icon-lg icon-create-circle"></i></a>
            </h3>
        </div>

        <div v-bind:id="data.id + 'Panel'" class="panel-collapse collapse" v-bind:class="{ 'in' : showFull }" role="tabpanel" v-bind:aria-labelledby="data.id + 'PanelHeading'">
            <datatable v-if="data.id != 'emailaccount'" :data="data" :count.sync="count"></datatable>
            <email-account v-if="data.id == 'emailaccount'" :accounts="accounts"></email-account>
        </div>
    </div>
</template>

<script>
    var Datatable = require('./datatable.vue').default;
    export default
    {
        props: {
            data: { default: {
                id: 'null'
            } },
            accounts: { default: '' }
        },
        data: function() {
            return {
                window_width: window.outerWidth,
                url: '',
                count: 0,
                loading: true,
                footer: false,
                timeout: false,
                rows: []
            };
        },

        created() {
            window.onfocus = function() {
                this.window_width = window.outerWidth;
            };

            this.$eventHub.$on('countUpdate' + this.data.id, this.countUpdate);
            this.url = this.data.url + '/create';
            if(typeof this.data.modal === 'undefined') {
                this.data.modal = false;
            }
            if(typeof this.data.link === 'undefined') {
                this.data.link = false;
            }
            if(this.data.id == 'emailaccount') {
                this.count = this.accounts.length;
            }
        },
        computed: {
            showFull() {
                if (this.window_width && this.window_width < 860) {
                    return false;
                }
                if(this.data.id == 'emailaccount'){
                    return false;
                }
                return this.count;
            },
            checkDisabled() {
                return (typeof this.data['link'] !== 'undefined' && typeof this.data.link['disable'] !== 'undefined' && this.data.link.disable);
            }
        },
        methods : {
            countUpdate: function(count) {
                this.count = count;
            },
            checkModal: function (event) {
                if (this.data.link.modal) {
                    event.preventDefault();
                    $('#boldModal').modal({ remote: this.data.link.href });
                    return false;
                }
            },
            newItemAlt: function () {
                let type = this.data.id;
                if (window.isInternal === '1' && type === 'website') {
                    type = 'awswebsite';
                }
                this.$eventHub.$emit('createDialog', type);
            },
            newItem: function () {
                let type = this.data.id;
                this.$eventHub.$emit('createDialog', type);
                /*if (this.data.id == 'email') {
                    this.$parent.create();
                    return false;
                }
                if(this.data.id == 'invoice') {
                    this.$root.invoiceList(window.company_id);
                    return false;
                }
                var url = this.url;
                // HACK
                if (this.data.link.disable) {
                    url = '/upgrade';
                }
                if (!this.data.modal) {
                    // Load Page Directly
                    window.location = url;
                    return;
                }
                if (this.data.modal_id) {
                    $(this.data.modal_id).modal();
                    return;
                }
                var boldModal =  $('#boldModal');
                var vm = this;
                boldModal.on('shown.bs.modal', function (e) {
//                  vm.$root.$compile(boldModal.get(0));
                });
                boldModal.modal({ remote: url });*/
            },
            togglePanel: function () {
                myToggle2(this.data.id);
            }
        },

        components:{
            'datatable': Datatable,
            'email-account': require('../components/email-account.vue').default
        }
    };
</script>
<style lang="less" scoped>
    .btn-archive {
        background: none;
        border: none;
        i {
            padding-top: 5px;
            font-size: 21px!important;
        }
    }
</style>